import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pullRequestListTitle: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list-title',
		defaultMessage: 'Linked pull requests',
		description: 'The title of the pull requests list.',
	},
	pullRequestListDescription: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list-description',
		defaultMessage: 'Your team’s linked pull requests from the last 30 days.',
		description: 'The description of the pull request list when at least one pull request visible.',
	},
	pullRequestListLearnMore: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list-learn-more',
		defaultMessage: 'Learn more',
		description:
			'The text for the link to an informational page explaining more about the feature.',
	},
	pullRequestsErrorStateTitle: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-requests-error-state-title',
		defaultMessage: 'We couldn’t load your pull requests',
		description:
			'The title used shown when a error occurs in the pull request list. Lets the user know something went wrong.',
	},
});
